/**
 * Who may change a user type: the Owner always, an Admin only while this is true, a Member only
 * with the explicit permission. Off by default (product has not confirmed it; assumption: confirm
 * with Thomas / Edgardo), so flipping it is the whole change.
 */
export const ADMIN_CAN_CHANGE_USER_TYPE = false;
